import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { designTokens, baseColors } from "theme";

export const styles = (theme: Theme) => ({
	scrollPaper: {
		alignItems: "baseline",
	},
	cancel: {
		marginLeft: 15
	},
	chipSelected: {
		border: `1.5px solid ${designTokens.colors.brandOrange}`,
		color: designTokens.colors.brandOrange,
		background: '#FFF3EC',
		margin: '3px',
		padding: '4px 16px',
	},
	chipUnselected: {
		border: `1.5px solid ${designTokens.colors.divider}`,
		color: baseColors.teal600,
		background: baseColors.white,
		margin: '3px',
		padding: '4px 16px',
	},
	groupCard: {
		background: baseColors.gray50,
		border: `1px solid ${designTokens.colors.divider}`,
		borderRadius: 8,
		padding: 12,
		marginBottom: 8,
	},
	groupCardLabel: {
		color: baseColors.teal600,
		fontWeight: 600,
		display: 'block',
		marginBottom: 8,
	},
	chipLabelWithTooltip: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 6,
	},
	chipTooltipIcon: {
		display: 'inline-flex',
		alignItems: 'center',
	},

} satisfies Record<string, CSSObject>)